// Listen for dispatch event to rebind pikaday rebindFavouritesCalendar
let start, end, pax, datePickerStart, datePickerEnd;

window.addEventListener("rebindFavouritesSettings", function (e) {
    rebindFavouritesSettings();
});

function rebindFavouritesSettings() {

    let startElF = document.getElementById("js-select-start-favourites");
    let endElF = document.getElementById("js-select-end-favourites");
    let paxElpF = document.getElementById("js-select-pax-favourites");

    start =
        startElF !== null && startElF.getAttribute("data-start")
            ? startElF.getAttribute("data-start").toString()
            : null;

    end =
        endElF !== null && endElF.getAttribute("data-end")
            ? endElF.getAttribute("data-end").toString()
            : null;
    pax = paxElpF.value

    paxElpF.addEventListener(
        "change",
        () => {
            pax = paxElpF.value;
        },
        false
    );

    datePickerStart = window.flatpickr(document.getElementById('js-select-start-favourites'), {
        plugins: [new window.yearDropdownPlugin({
            date: start ? dayjs(start).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
            yearStart: 0,
            yearEnd: 2
        })],
        position: "below",
        mode: 'single',
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'j M Y',
        locale: {
            firstDayOfWeek: 1
        },
        minDate: 'today',
        disableMobile: true,
        maxDate: dayjs().add(2, 'year').toDate(),
        defaultDate: start ? dayjs(start).format('YYYY-MM-DD') : '',
        onValueUpdate: (selectedDates, dateString) => {
            if (dateString != start) {
                let oldStart = start
                updateEnd(oldStart, dayjs(dateString).format('YYYY-MM-DD')) // sending the old start date before it is updated
                start = dayjs(dateString).format('YYYY-MM-DD')

                // this.$nextTick(() => this.$store.search.houseKeeping('end'))
            }
        },
        onClose: () => {

            if (end == '') {
                datePickerStart.clear() // not using clear since sets date to []
            }
        }
    })

    datePickerEnd = window.flatpickr(document.getElementById('js-select-end-favourites'), {
        plugins: [new window.yearDropdownPlugin({
            date: end ? dayjs(end).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
            yearStart: 0,
            yearEnd: 2
        })],
        position: "below",
        mode: 'single',
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'j M Y',
        locale: {
            firstDayOfWeek: 1
        },
        minDate: dayjs(start).add(1, 'day').format('YYYY-MM-DD'),
        disableMobile: true,
        maxDate: dayjs().add(2, 'year').toDate(),
        defaultDate: end ? dayjs(end).format('YYYY-MM-DD') : '',
        onValueUpdate: (selectedDates, dateString) => {
            if (dateString != end) {
                end = dayjs(dateString).format('YYYY-MM-DD')
                // this.$nextTick(() => this.$store.search.houseKeeping('end'))
            }
        },
    })
}

function updateEnd(oldStartDate, newStart) {

    let newMinDate = newStart != '' ? dayjs(newStart).add(1, 'day') : dayjs().add(1, 'day')
    // Move length of stay to equal length of stay between start and end dates
    if (oldStartDate != ''
        && end != ''
        && dayjs(end).diff(dayjs(newMinDate), 'day') < 0) {
        let originalDayLength = dayjs(end).diff(dayjs(oldStartDate), 'day')
        datePickerEnd.setDate(dayjs(newMinDate).add(originalDayLength, 'day').format('YYYY-MM-DD'))
    } else if (end != '' && dayjs(end).diff(dayjs(newMinDate), 'day') < 0) {
        end = ''
        datePickerEnd.clear()
    }

    // End date is minimum of start date + 1 day
    datePickerEnd.set('minDate', dayjs(newMinDate).toDate())
}

// Prompt date pickers if fields left out
window.addEventListener("showFavouritesStartPicker", function (e) {
    datePickerStart.open();
});
window.addEventListener("showFavouritesEndPicker", function (e) {
    datePickerEnd.open();
});
